import React from 'react';
import CookieConsent from '../components/CookieConsent';
import { Header } from '../components/shared/Header';
import { Footer } from '../components/shared/Footer';
import { HeroSection } from '../components/home/HeroSection';
import { CredentialsBar } from '../components/home/CredentialsBar';
import { ServicesSection } from '../components/home/ServicesSection';
import { AboutSection } from '../components/home/AboutSection';
import { HerancasCallout } from '../components/home/HerancasCallout';
import { ProcessSection } from '../components/home/ProcessSection';
import { FAQSection } from '../components/home/FAQSection';
import { ReviewsSection } from '../components/home/ReviewsSection';
import { MapLeadSection } from '../components/home/MapLeadSection';
import { ContactSection } from '../components/home/ContactSection';
import { useSeo } from '../lib/seo';
import '../App.css';

const NAV_ITEMS = [
  { label: 'Serviços', href: '#servicos' },
  { label: 'Sobre', href: '#sobre' },
  { label: 'Heranças', href: '/herancas' },
  { label: 'FAQ', href: '#faq' },
  { label: 'Contacto', href: '#contacto' }
];

function Home() {
  useSeo({
    title: 'Valuare JR | Avaliador Imobiliário Certificado CMVM',
    description:
      'Avaliações certificadas CMVM na Grande Lisboa e Setúbal. Relatório aceite por notários, tribunais e bancos. Proposta no próprio dia, sem compromisso.',
    url: 'https://valuarejr.com/'
  });

  return (
    <div className="valuare-app">
      <Header navItems={NAV_ITEMS} />
      <HeroSection />
      <CredentialsBar />
      <MapLeadSection />
      <ServicesSection />
      <AboutSection />
      <HerancasCallout />
      <ProcessSection />
      <FAQSection />
      <ReviewsSection />
      <ContactSection />
      <Footer />
      <CookieConsent />
    </div>
  );
}

export default Home;
